import React, { useCallback, useState, lazy, Suspense } from 'react';
import {
  Button,
  TextInput,
  NumberInput,
  Select,
  SelectItem,
  Checkbox,
  DataTable,
  TableRow,
  TableHead,
  TableHeader,
  TableContainer,
  TableCell,
  Table,
  TableBody,
  TableToolbar,
  TableToolbarContent,
} from 'carbon-components-react';

import Collapsible from 'react-collapsible';
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import { Tooltip as ReactTooltip } from "react-tooltip";


import { safeLoad, getDivHeight, jsonToYaml, updateStyle, updateStyle2, validateField, toggleDescription } from '../../helpers';

const LoggingcomponentsDeleteModal = lazy(() => import('./loggingcomponentsDeleteModal'));
const LoggingcomponentsAdd = lazy(() => import('./loggingcomponentsAdd'));
const LoggingcomponentsEdit = lazy(() => import('./loggingcomponentsEdit'));
const LoggingstatisticscomponentsDeleteModal = lazy(() => import('./loggingstatisticscomponentsDeleteModal'));
const LoggingstatisticscomponentsAdd = lazy(() => import('./loggingstatisticscomponentsAdd'));
const LoggingstatisticscomponentsEdit = lazy(() => import('./loggingstatisticscomponentsEdit'));
const LoggingtracingDeleteModal = lazy(() => import('./loggingtracingDeleteModal'));
const LoggingtracingAdd = lazy(() => import('./loggingtracingAdd'));
const LoggingtracingEdit = lazy(() => import('./loggingtracingEdit'));


const handleChange = () =>{
    var yamlText = window.iagyaml;

    var json = {};

    if(yamlText !== null && yamlText !== undefined) {
        json = safeLoad(yamlText);
        if(json === undefined || json === null) {
          json = {};
        }
    }

    var newElem = {};
    newElem["json_logging"] = document.getElementById("logging_json_logging_id").checked.toString();
    newElem["language"] = document.getElementById("logging_language_id").value;
    var newrequest_log = {};
    var newfile = {};
    newfile["compress"] = document.getElementById("logging_request_log_file_compress_id").checked.toString();
    if(document.getElementById("logging_request_log_file_file_name_id").value.endsWith(":") !== true) {
    newfile["file_name"] = document.getElementById("logging_request_log_file_file_name_id").value;
    }
    newfile["max_file_size"] = document.getElementById("logging_request_log_file_max_file_size_id").value;
    newfile["max_rollover_files"] = document.getElementById("logging_request_log_file_max_rollover_files_id").value;
    newrequest_log["file"] = newfile;
    if(document.getElementById("logging_request_log_format_id").value.endsWith(":") !== true) {
    newrequest_log["format"] = document.getElementById("logging_request_log_format_id").value;
    }
    newElem["request_log"] = newrequest_log;
    var newstatistics = {};
    newstatistics["frequency"] = document.getElementById("logging_statistics_frequency_id").value;
    newstatistics["port"] = document.getElementById("logging_statistics_port_id").value;
    if(document.getElementById("logging_statistics_server_id").value.endsWith(":") !== true) {
    newstatistics["server"] = document.getElementById("logging_statistics_server_id").value;
    }
    newstatistics["components"] = logging_statistics_componentsrowData.logging_statistics_components;
    newElem["statistics"] = newstatistics;
    var newtransaction = {};
    newtransaction["compress"] = document.getElementById("logging_transaction_compress_id").checked.toString();
    if(document.getElementById("logging_transaction_file_name_id").value.endsWith(":") !== true) {
    newtransaction["file_name"] = document.getElementById("logging_transaction_file_name_id").value;
    }
    newtransaction["max_file_size"] = document.getElementById("logging_transaction_max_file_size_id").value;
    newtransaction["max_files"] = document.getElementById("logging_transaction_max_files_id").value;
    newElem["transaction"] = newtransaction;
    newElem["tracing"] = logging_tracingrowData.logging_tracing;
    newElem["components"] = logging_statistics_componentsrowData.logging_statistics_components;
    newElem["components"] = logging_componentsrowData.logging_components;
    json["logging"] = newElem;

    var yamlop = jsonToYaml(json);
    window.iagyaml = yamlop;
};

  const closeAdd = (idPrefix) => {

      if(idPrefix === undefined) idPrefix = "";

      updateStyle("logging_div" + idPrefix, "display", "block");
      document.getElementById("logging_tab" + idPrefix).style.display = "flex";

  };

const logging_componentsheaderData = [
    {
    header: 'Component',
    key: 'components',
  },

];

const logging_componentsrowData = {logging_components: []};

const logging_componentshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("logging_components_components_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("logging_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addlogging_componentsPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("logging_tab" + idPrefix).style.display = "none";

  };
const logging_statistics_componentsheaderData = [
    {
    header: 'Component',
    key: 'components',
  },

];

const logging_statistics_componentsrowData = {logging_statistics_components: []};

const logging_statistics_componentshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("logging_statistics_components_components_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("logging_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addloggingstatistics_componentsPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("logging_tab" + idPrefix).style.display = "none";

  };
const logging_tracingheaderData = [
    {
    header: 'Component',
    key: 'component',
  },
{
    header: 'Compress',
    key: 'compress',
  },
{
    header: 'File Name',
    key: 'file_name',
  },
{
    header: 'Level',
    key: 'level',
  },
{
    header: 'Max File Size',
    key: 'max_file_size',
  },
{
    header: 'Max Rollover Files',
    key: 'max_rollover_files',
  },

];

const logging_tracingrowData = {logging_tracing: []};

const logging_tracinghandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("logging_tracing_component_id" + idPrefix).value = "";
    document.getElementById("logging_tracing_compress_id" + idPrefix).value = "";
    document.getElementById("logging_tracing_file_name_id" + idPrefix).value = "";
    document.getElementById("logging_tracing_level_id" + idPrefix).value = "";
    document.getElementById("logging_tracing_max_file_size_id" + idPrefix).value = "";
    document.getElementById("logging_tracing_max_rollover_files_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("logging_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addlogging_tracingPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("logging_tab" + idPrefix).style.display = "none";

  };


const LoggingPage = () => {

  const idPrefix = "";

  if(window.iagpage != "LoggingPage") {
    delete(window.editing);
    delete(window.rowId);
    window.iagpage = "LoggingPage";
  }

    const [logging_components, setlogging_components] = React.useState([]);
    const [fetchedlogging_components, setFetchedlogging_components] = React.useState(false);

    React.useEffect(() => {
      logging_componentsloadGrid();
    }, [fetchedlogging_components]);

    const logging_componentsloadGrid = React.useCallback(async (logging_components_components, add) => {
      try {
        var attrs = [];
        if(logging_components_components) {
          if(add) {
            for(var i = 0; i < logging_componentsrowData.logging_components.length; i++) {
              var tempId = ((logging_componentsrowData.logging_components[i].components)?logging_componentsrowData.logging_components[i].components:"") + "";
              if((window.logging_componentsediting != true && window.logging_componentsediting != "true") || tempId != window.logging_componentsrowId) {
                attrs.push(logging_componentsrowData.logging_components[i]);
              }
            }
            var newId = ((logging_components_components)?logging_components_components:"") + "";
            attrs.push({
              id: newId,
              components: logging_components_components,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < logging_componentsrowData.logging_components.length; i++) {
              if(logging_componentsrowData.logging_components[i].components !== logging_components_components ) {
                attrs.push(logging_componentsrowData.logging_components[i]);
              }
            }
          }
        } else {
          attrs = logging_componentsrowData.logging_components;
        }
        logging_componentsrowData.logging_components = attrs;
        const data = {logging_components: attrs};
        setlogging_components(data.logging_components);

        if(logging_components_components !== undefined && logging_components_components !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [logging_statistics_components, setlogging_statistics_components] = React.useState([]);
    const [fetchedlogging_statistics_components, setFetchedlogging_statistics_components] = React.useState(false);

    React.useEffect(() => {
      logging_statistics_componentsloadGrid();
    }, [fetchedlogging_statistics_components]);

    const logging_statistics_componentsloadGrid = React.useCallback(async (logging_statistics_components_components, add) => {
      try {
        var attrs = [];
        if(logging_statistics_components_components) {
          if(add) {
            for(var i = 0; i < logging_statistics_componentsrowData.logging_statistics_components.length; i++) {
              var tempId = ((logging_statistics_componentsrowData.logging_statistics_components[i].components)?logging_statistics_componentsrowData.logging_statistics_components[i].components:"") + "";
              if((window.logging_statistics_componentsediting != true && window.logging_statistics_componentsediting != "true") || tempId != window.logging_statistics_componentsrowId) {
                attrs.push(logging_statistics_componentsrowData.logging_statistics_components[i]);
              }
            }
            var newId = ((logging_statistics_components_components)?logging_statistics_components_components:"") + "";
            attrs.push({
              id: newId,
              components: logging_statistics_components_components,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < logging_statistics_componentsrowData.logging_statistics_components.length; i++) {
              if(logging_statistics_componentsrowData.logging_statistics_components[i].components !== logging_statistics_components_components ) {
                attrs.push(logging_statistics_componentsrowData.logging_statistics_components[i]);
              }
            }
          }
        } else {
          attrs = logging_statistics_componentsrowData.logging_statistics_components;
        }
        logging_statistics_componentsrowData.logging_statistics_components = attrs;
        const data = {logging_statistics_components: attrs};
        setlogging_statistics_components(data.logging_statistics_components);

        if(logging_statistics_components_components !== undefined && logging_statistics_components_components !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [logging_tracing, setlogging_tracing] = React.useState([]);
    const [fetchedlogging_tracing, setFetchedlogging_tracing] = React.useState(false);

    React.useEffect(() => {
      logging_tracingloadGrid();
    }, [fetchedlogging_tracing]);

    const logging_tracingloadGrid = React.useCallback(async (logging_tracing_component, logging_tracing_compress, logging_tracing_file_name, logging_tracing_level, logging_tracing_max_file_size, logging_tracing_max_rollover_files, add) => {
      try {
        var attrs = [];
        if(logging_tracing_component || logging_tracing_file_name) {
          if(add) {
            for(var i = 0; i < logging_tracingrowData.logging_tracing.length; i++) {
              var tempId = ((logging_tracingrowData.logging_tracing[i].component)?logging_tracingrowData.logging_tracing[i].component:"") + ((logging_tracingrowData.logging_tracing[i].file_name)?logging_tracingrowData.logging_tracing[i].file_name:"") + "";
              if((window.logging_tracingediting != true && window.logging_tracingediting != "true") || tempId != window.logging_tracingrowId) {
                attrs.push(logging_tracingrowData.logging_tracing[i]);
              }
            }
            var newId = ((logging_tracing_component)?logging_tracing_component:"") + ((logging_tracing_file_name)?logging_tracing_file_name:"") + "";
            attrs.push({
              id: newId,
              component: logging_tracing_component,
compress: logging_tracing_compress,
file_name: logging_tracing_file_name,
level: logging_tracing_level,
max_file_size: logging_tracing_max_file_size,
max_rollover_files: logging_tracing_max_rollover_files,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < logging_tracingrowData.logging_tracing.length; i++) {
              if(logging_tracingrowData.logging_tracing[i].component !== logging_tracing_component  && logging_tracingrowData.logging_tracing[i].file_name !== logging_tracing_file_name ) {
                attrs.push(logging_tracingrowData.logging_tracing[i]);
              }
            }
          }
        } else {
          attrs = logging_tracingrowData.logging_tracing;
        }
        logging_tracingrowData.logging_tracing = attrs;
        const data = {logging_tracing: attrs};
        setlogging_tracing(data.logging_tracing);

        if(logging_tracing_component !== undefined && logging_tracing_component !== null  && logging_tracing_file_name !== undefined && logging_tracing_file_name !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });



    const [logging_components_components, setlogging_components_components] = useState(''),
    updatelogging_components_components = useCallback((evt) => {
      setlogging_components_components(evt.target.value);
      var tempId = evt.target.value;
      validateField(logging_componentsrowData.logging_components, setlogging_components_components_valid, setlogging_components_components_invalid_text, "Logging Components", "components", tempId);
    }, []);

    const [logging_components_components_valid, setlogging_components_components_valid] = useState(true);
    const [logging_components_components_invalid_text, setlogging_components_components_invalid_text] = useState("");


    const [logging_json_logging, setlogging_json_logging] = useState(false),
    updatelogging_json_logging = useCallback((evt) => setlogging_json_logging(evt), []);

    const [logging_language, setlogging_language] = useState('en'),
    updatelogging_language = useCallback((evt) => setlogging_language(evt.target.value), []);

    const [logging_request_log_file_compress, setlogging_request_log_file_compress] = useState(true),
    updatelogging_request_log_file_compress = useCallback((evt) => setlogging_request_log_file_compress(evt), []);

    const [logging_request_log_file_file_name, setlogging_request_log_file_file_name] = useState(''),
    updatelogging_request_log_file_file_name = useCallback((evt) => setlogging_request_log_file_file_name(evt.target.value), []);

    const [logging_request_log_file_max_file_size, setlogging_request_log_file_max_file_size] = useState(1),
    updatelogging_request_log_file_max_file_size = useCallback((evt) => {}, []);

    const [logging_request_log_file_max_rollover_files, setlogging_request_log_file_max_rollover_files] = useState(1),
    updatelogging_request_log_file_max_rollover_files = useCallback((evt) => {}, []);

    const [logging_request_log_format, setlogging_request_log_format] = useState('"%h %u %t %r %s %b"'),
    updatelogging_request_log_format = useCallback((evt) => setlogging_request_log_format(evt.target.value), []);

    const [logging_statistics_components_components, setlogging_statistics_components_components] = useState(''),
    updatelogging_statistics_components_components = useCallback((evt) => {
      setlogging_statistics_components_components(evt.target.value);
      var tempId = evt.target.value;
      validateField(logging_statistics_componentsrowData.logging_statistics_components, setlogging_statistics_components_components_valid, setlogging_statistics_components_components_invalid_text, "Logging Statistics Components", "components", tempId);
    }, []);

    const [logging_statistics_components_components_valid, setlogging_statistics_components_components_valid] = useState(true);
    const [logging_statistics_components_components_invalid_text, setlogging_statistics_components_components_invalid_text] = useState("");


    const [logging_statistics_frequency, setlogging_statistics_frequency] = useState(1),
    updatelogging_statistics_frequency = useCallback((evt) => {}, []);

    const [logging_statistics_port, setlogging_statistics_port] = useState(8125),
    updatelogging_statistics_port = useCallback((evt) => {}, []);

    const [logging_statistics_server, setlogging_statistics_server] = useState(''),
    updatelogging_statistics_server = useCallback((evt) => setlogging_statistics_server(evt.target.value), []);

    const [logging_tracing_component, setlogging_tracing_component] = useState(''),
    updatelogging_tracing_component = useCallback((evt) => {
      setlogging_tracing_component(evt.target.value);
      var file_nameWdgt = document.getElementById("logging_tracing_file_name_id" + idPrefix);
      var file_nameVal = (file_nameWdgt)?file_nameWdgt.value:"";
      var tempId = evt.target.value + file_nameVal;
      validateField(logging_tracingrowData.logging_tracing, setlogging_tracing_file_name_valid, setlogging_tracing_file_name_invalid_text, "Logging Tracing", "unique values", tempId);
      validateField(logging_tracingrowData.logging_tracing, setlogging_tracing_component_valid, setlogging_tracing_component_invalid_text, "Logging Tracing", "unique values", tempId);
    }, []);

    const [logging_tracing_component_valid, setlogging_tracing_component_valid] = useState(true);
    const [logging_tracing_component_invalid_text, setlogging_tracing_component_invalid_text] = useState("");


    const [logging_tracing_compress, setlogging_tracing_compress] = useState(true),
    updatelogging_tracing_compress = useCallback((evt) => setlogging_tracing_compress(evt), []);

    const [logging_tracing_file_name, setlogging_tracing_file_name] = useState(''),
    updatelogging_tracing_file_name = useCallback((evt) => {
      setlogging_tracing_file_name(evt.target.value);
      var componentWdgt = document.getElementById("logging_tracing_component_id" + idPrefix);
      var componentVal = (componentWdgt)?componentWdgt.value:"";
      var tempId = componentVal + evt.target.value;
      validateField(logging_tracingrowData.logging_tracing, setlogging_tracing_component_valid, setlogging_tracing_component_invalid_text, "Logging Tracing", "unique values", tempId);
      validateField(logging_tracingrowData.logging_tracing, setlogging_tracing_file_name_valid, setlogging_tracing_file_name_invalid_text, "Logging Tracing", "unique values", tempId);
    }, []);

    const [logging_tracing_file_name_valid, setlogging_tracing_file_name_valid] = useState(true);
    const [logging_tracing_file_name_invalid_text, setlogging_tracing_file_name_invalid_text] = useState("");


    const [logging_tracing_level, setlogging_tracing_level] = useState(0),
    updatelogging_tracing_level = useCallback((evt) => {}, []);

    const [logging_tracing_max_file_size, setlogging_tracing_max_file_size] = useState(1),
    updatelogging_tracing_max_file_size = useCallback((evt) => {}, []);

    const [logging_tracing_max_rollover_files, setlogging_tracing_max_rollover_files] = useState(1),
    updatelogging_tracing_max_rollover_files = useCallback((evt) => {}, []);

    const [logging_transaction_compress, setlogging_transaction_compress] = useState(false),
    updatelogging_transaction_compress = useCallback((evt) => setlogging_transaction_compress(evt), []);

    const [logging_transaction_file_name, setlogging_transaction_file_name] = useState(''),
    updatelogging_transaction_file_name = useCallback((evt) => setlogging_transaction_file_name(evt.target.value), []);

    const [logging_transaction_max_file_size, setlogging_transaction_max_file_size] = useState(262144),
    updatelogging_transaction_max_file_size = useCallback((evt) => {}, []);

    const [logging_transaction_max_files, setlogging_transaction_max_files] = useState(1),
    updatelogging_transaction_max_files = useCallback((evt) => {}, []);


  if(window.iagpage != "LoggingPage") {
    delete(window.editing);
    delete(window.rowId);
    window.iagpage = "LoggingPage";
  }

    const [fetcheddata, setFetcheddata] = React.useState(false);
    React.useEffect(() => {
      dataLoad();
    }, [fetcheddata]);
    const dataLoad = () => {
      var yamlText = window.iagyaml;
      var json = {};
      if(yamlText !== null && yamlText !== undefined) {
        json = safeLoad(yamlText);
        if(json === undefined || json === null) {
          json = {};
        }
      }

      for(var i = 0; i < logging_componentsrowData.logging_components.length; i++) {
        if(logging_componentsrowData.logging_components[i].id === window.logging_componentsrowId) {
        setlogging_components_components((logging_componentsrowData.logging_components[i] !== undefined && logging_componentsrowData.logging_components[i].components !== undefined )?logging_componentsrowData.logging_components[i].components:"");
        }
      }

      for(var i = 0; i < logging_statistics_componentsrowData.logging_statistics_components.length; i++) {
        if(logging_statistics_componentsrowData.logging_statistics_components[i].id === window.logging_statistics_componentsrowId) {
        setlogging_statistics_components_components((logging_statistics_componentsrowData.logging_statistics_components[i] !== undefined && logging_statistics_componentsrowData.logging_statistics_components[i].components !== undefined )?logging_statistics_componentsrowData.logging_statistics_components[i].components:"");
        }
      }

      for(var i = 0; i < logging_tracingrowData.logging_tracing.length; i++) {
        if(logging_tracingrowData.logging_tracing[i].id === window.logging_tracingrowId) {
        setlogging_tracing_component((logging_tracingrowData.logging_tracing[i] !== undefined && logging_tracingrowData.logging_tracing[i].component !== undefined )?logging_tracingrowData.logging_tracing[i].component:"");
        setlogging_tracing_compress((logging_tracingrowData.logging_tracing[i] !== undefined && logging_tracingrowData.logging_tracing[i].compress !== undefined )?(logging_tracingrowData.logging_tracing[i].compress == true || logging_tracingrowData.logging_tracing[i].compress == "true"):false);
        setlogging_tracing_file_name((logging_tracingrowData.logging_tracing[i] !== undefined && logging_tracingrowData.logging_tracing[i].file_name !== undefined )?logging_tracingrowData.logging_tracing[i].file_name:"");
        setlogging_tracing_level((logging_tracingrowData.logging_tracing[i] !== undefined && logging_tracingrowData.logging_tracing[i].level !== undefined )?logging_tracingrowData.logging_tracing[i].level:"");
        setlogging_tracing_max_file_size((logging_tracingrowData.logging_tracing[i] !== undefined && logging_tracingrowData.logging_tracing[i].max_file_size !== undefined )?logging_tracingrowData.logging_tracing[i].max_file_size:"");
        setlogging_tracing_max_rollover_files((logging_tracingrowData.logging_tracing[i] !== undefined && logging_tracingrowData.logging_tracing[i].max_rollover_files !== undefined )?logging_tracingrowData.logging_tracing[i].max_rollover_files:"");
        }
      }


      return true;
    };
    const [fetchedlogging, setFetchedlogging] = React.useState(false);
    React.useEffect(() => {
      getlogging();
    }, [fetchedlogging]);

    const getlogging = () => {

      var yamlText = window.iagyaml;
      var json = {};
      if(yamlText !== null && yamlText !== undefined) {
        json = safeLoad(yamlText);
        if(json === undefined || json === null) {
          json = {};
        }
      }

            logging_componentsrowData.logging_components = [];
              logging_statistics_componentsrowData.logging_statistics_components = [];
            logging_tracingrowData.logging_tracing = [];

        if(json !== undefined && json.logging !== undefined ) {
          if(json !== undefined && json.logging !== undefined && json.logging.components !== undefined ) {
            var newcomponentss = [];
            for(var i = 0; i < json.logging.components.length; i++) {
                var newcomponents = {};
                newcomponents["id"] = json.logging.components[i];
                newcomponents["components"] = json.logging.components[i];
                newcomponentss.push(newcomponents);
                logging_componentsrowData.logging_components.push(newcomponents);
            }
            }
          if(json !== undefined && json.logging !== undefined && json.logging.json_logging !== undefined ) {
            setlogging_json_logging(json.logging.json_logging);
          }
          if(json !== undefined && json.logging !== undefined && json.logging.language !== undefined ) {
            setlogging_language(json.logging.language);
          }
          var newrequest_log = {};
          if(json !== undefined && json.logging !== undefined && json.logging.request_log !== undefined ) {
            var newfile = {};
            if(json !== undefined && json.logging !== undefined && json.logging.request_log !== undefined && json.logging.request_log.file !== undefined ) {
              if(json !== undefined && json.logging !== undefined && json.logging.request_log !== undefined && json.logging.request_log.file !== undefined && json.logging.request_log.file.compress !== undefined ) {
                setlogging_request_log_file_compress(json.logging.request_log.file.compress);
              }
              if(json !== undefined && json.logging !== undefined && json.logging.request_log !== undefined && json.logging.request_log.file !== undefined && json.logging.request_log.file.file_name !== undefined ) {
                setlogging_request_log_file_file_name(json.logging.request_log.file.file_name);
              }
              if(json !== undefined && json.logging !== undefined && json.logging.request_log !== undefined && json.logging.request_log.file !== undefined && json.logging.request_log.file.max_file_size !== undefined ) {
                setlogging_request_log_file_max_file_size(json.logging.request_log.file.max_file_size);
              }
              if(json !== undefined && json.logging !== undefined && json.logging.request_log !== undefined && json.logging.request_log.file !== undefined && json.logging.request_log.file.max_rollover_files !== undefined ) {
                setlogging_request_log_file_max_rollover_files(json.logging.request_log.file.max_rollover_files);
              }
            }
            newrequest_log["file"] = newfile;
            if(json !== undefined && json.logging !== undefined && json.logging.request_log !== undefined && json.logging.request_log.format !== undefined ) {
              setlogging_request_log_format(json.logging.request_log.format);
            }
          }
          var newstatistics = {};
          if(json !== undefined && json.logging !== undefined && json.logging.statistics !== undefined ) {
            if(json !== undefined && json.logging !== undefined && json.logging.statistics !== undefined && json.logging.statistics.components !== undefined ) {
              var newcomponentss = [];
              for(var i = 0; i < json.logging.statistics.components.length; i++) {
                  var newcomponents = {};
                  newcomponents["id"] = json.logging.statistics.components[i];
                  newcomponents["components"] = json.logging.statistics.components[i];
                  newcomponentss.push(newcomponents);
                  logging_statistics_componentsrowData.logging_statistics_components.push(newcomponents);
              }
              }
            if(json !== undefined && json.logging !== undefined && json.logging.statistics !== undefined && json.logging.statistics.frequency !== undefined ) {
              setlogging_statistics_frequency(json.logging.statistics.frequency);
            }
            if(json !== undefined && json.logging !== undefined && json.logging.statistics !== undefined && json.logging.statistics.port !== undefined ) {
              setlogging_statistics_port(json.logging.statistics.port);
            }
            if(json !== undefined && json.logging !== undefined && json.logging.statistics !== undefined && json.logging.statistics.server !== undefined ) {
              setlogging_statistics_server(json.logging.statistics.server);
            }
          }
          if(json !== undefined && json.logging !== undefined && json.logging.tracing !== undefined ) {
            var newtracings = [];
            for(var i = 0; i < json.logging.tracing.length; i++) {
              var newItem = {};
              var tempId = ((json.logging.tracing[i].component)?json.logging.tracing[i].component:"") + ((json.logging.tracing[i].file_name)?json.logging.tracing[i].file_name:"");
              newItem["id"] = tempId;
              newItem["component"] = json.logging.tracing[i].component;
              newItem["compress"] = json.logging.tracing[i].compress;
              newItem["file_name"] = json.logging.tracing[i].file_name;
              newItem["level"] = json.logging.tracing[i].level;
              newItem["max_file_size"] = json.logging.tracing[i].max_file_size;
              newItem["max_rollover_files"] = json.logging.tracing[i].max_rollover_files;
              logging_tracingrowData.logging_tracing.push(newItem);
            }
            }
          var newtransaction = {};
          if(json !== undefined && json.logging !== undefined && json.logging.transaction !== undefined ) {
            if(json !== undefined && json.logging !== undefined && json.logging.transaction !== undefined && json.logging.transaction.compress !== undefined ) {
              setlogging_transaction_compress(json.logging.transaction.compress);
            }
            if(json !== undefined && json.logging !== undefined && json.logging.transaction !== undefined && json.logging.transaction.file_name !== undefined ) {
              setlogging_transaction_file_name(json.logging.transaction.file_name);
            }
            if(json !== undefined && json.logging !== undefined && json.logging.transaction !== undefined && json.logging.transaction.max_file_size !== undefined ) {
              setlogging_transaction_max_file_size(json.logging.transaction.max_file_size);
            }
            if(json !== undefined && json.logging !== undefined && json.logging.transaction !== undefined && json.logging.transaction.max_files !== undefined ) {
              setlogging_transaction_max_files(json.logging.transaction.max_files);
            }
          }
        }
    };



    const setDataMain = (functionName, data) => {
      if(functionName && data) {
        eval(functionName)(data);
      }
    };

    return (
        <div className="bx--grid--no-gutter bx--grid--full-width landing-page">
          <div className="bx--row landing-page__banner" style={{paddingBottom:"3rem"}}>
            <div className="bx--col-lg-13 bx--offset-lg-1">
              <h1 className="landing-page__heading">
                Logging
              </h1>
            </div>
            <div className="bx--col-lg-13 bx--offset-lg-1">
              <h4 className="landing-page__desc" style={{marginTop:"30px"}}>The `logging` node defines the configuration entries which are used to manage the various logging capabilities of the IBM Application Gateway.
</h4>
            </div>            <div id="warning_div" className="bx--col-lg-13" style={{display:'none', color:'red', position:'absolute', bottom:'0', marginBottom: '10px'}}></div>
          </div>
          <div className="bx--row landing-page__r2">
            <div className="bx--col bx--no-gutter">
              <div id="loggingPage" className="bx--col">
                <br/><br/><br/>
            <Tabs id={"logging_tab" + idPrefix} defaultTab={"General_tab" + idPrefix} vertical className="vertical-tabs" style={{overflow:'auto'}}>
              <TabList>
                <Tab tabFor={"General_tab" + idPrefix}>General</Tab>
                <Tab tabFor={"components_tab" + idPrefix}>Components</Tab>
                <Tab tabFor={"request_log_tab" + idPrefix}>Request Log</Tab>
                <Tab tabFor={"statistics_tab" + idPrefix}>Statistics</Tab>
                <Tab tabFor={"tracing_tab" + idPrefix}>Tracing</Tab>
                <Tab tabFor={"transaction_tab" + idPrefix}>Transaction</Tab>
              </TabList>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"components_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading logging_div" + idPrefix}>
                  <span className="iag_breadcrumb">Logging : </span><br/>                  <h2>Components Settings</h2><hr/>
                </div>
                <div className={"iag--simple-div logging_div" + idPrefix}>
                <div className= {"iag_form_elem logging_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"logging_components_tooltip_id" + idPrefix} >Components</h3><hr/>
</div>
          <ReactTooltip id={"logging_components_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>Specifies an array of auditing components to be enabled.<br/></div></ReactTooltip>

                <div id={"logging_componentsTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem logging_div" + idPrefix}>
                    <DataTable id={"logging_componentsTable" + idPrefix} isSortable
                        headers={logging_componentsheaderData}
                        rows={logging_componentsrowData.logging_components}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {logging_componentshandleAdd(idPrefix, [setlogging_components_components(''),    setlogging_components_components_valid(true),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <LoggingcomponentsDeleteModal row={row} loadGrid={logging_componentsloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <LoggingcomponentsEdit  data={logging_componentsrowData.logging_components} setData={setDataMain} row={row} loadGrid={logging_componentsloadGrid} dataLoad={dataLoad} editing={true} name={"logging_components"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updatelogging_components_components={updatelogging_components_components} logging_components_components={logging_components_components}
            logging_components_components_valid={logging_components_components_valid}
            logging_components_components_invalid_text={logging_components_components_invalid_text}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"transaction_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading logging_div" + idPrefix}>
                  <span className="iag_breadcrumb">Logging : </span><br/>                  <h2>Transaction Settings</h2><hr/>
                  <Collapsible tabIndex="0" trigger="Defines and enables transaction logging">
                    <p>Defines and enables transaction logging. This logging can be used to pinpoint performance issues in the environment.</p>
                  </Collapsible>

                </div>
                <div className={"iag--simple-div logging_div" + idPrefix}>
                <div className= {"iag_form_elem logging_div" + idPrefix}>
          <Checkbox checked={logging_transaction_compress} id={"logging_transaction_compress_id" + idPrefix}  data-tooltip-id={"logging_transaction_compress_tooltip_id" + idPrefix}  labelText="Compress" onChange={(evt) => { updatelogging_transaction_compress(evt); handleChange(); }}/>
          <ReactTooltip id={"logging_transaction_compress_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>A boolean which indicates whether the generated file should be compressed. If not specified the files will not be compressed.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem logging_div" + idPrefix}>
          <TextInput  value={logging_transaction_file_name}  id={"logging_transaction_file_name_id" + idPrefix}  data-tooltip-id={"logging_transaction_file_name_tooltip_id" + idPrefix}  labelText="File Name *" onChange={(evt) => { updatelogging_transaction_file_name(evt); handleChange(); }}/>
          <ReactTooltip id={"logging_transaction_file_name_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The name of the generated log file.  If the file name is supplied without any path information the file will be written to the `/var/iag/logs` directory.  If the file name contains path information the hosting directory must be created and available before the container is started.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem logging_div" + idPrefix}>
          <NumberInput value={logging_transaction_max_file_size} id={"logging_transaction_max_file_size_id" + idPrefix}  data-tooltip-id={"logging_transaction_max_file_size_tooltip_id" + idPrefix}  min={1}  label="Max File Size" onChange={(evt) => { updatelogging_transaction_max_file_size(evt); handleChange(); }}/>
          <ReactTooltip id={"logging_transaction_max_file_size_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The maximum size of the log file (in kilobytes) before it is rolled over. If not specified the file size is 262144 KB (256MB).<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem logging_div" + idPrefix}>
          <NumberInput value={logging_transaction_max_files} id={"logging_transaction_max_files_id" + idPrefix}  data-tooltip-id={"logging_transaction_max_files_tooltip_id" + idPrefix}  min={1}  label="Max Files" onChange={(evt) => { updatelogging_transaction_max_files(evt); handleChange(); }}/>
          <ReactTooltip id={"logging_transaction_max_files_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The maximum number of files to be created, including rollover files. If not specified the max number of files is unlimited.<br/></div></ReactTooltip>
        </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"General_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading logging_div" + idPrefix}>
                  <span className="iag_breadcrumb">Logging : </span><br/>                  <h2>General Settings</h2><hr/>
                  Specifies the general settings associated with this component
                </div>
                <div className={"iag--simple-div logging_div" + idPrefix}>
                <div className= {"iag_form_elem logging_div" + idPrefix}>
          <Checkbox checked={logging_json_logging} id={"logging_json_logging_id" + idPrefix}  data-tooltip-id={"logging_json_logging_tooltip_id" + idPrefix}  labelText="JSON Logging" onChange={(evt) => { updatelogging_json_logging(evt); handleChange(); }}/>
          <ReactTooltip id={"logging_json_logging_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>A boolean which indicates whether the logging will be in JSON format or not. If not specified logging will not be in JSON format.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem logging_div" + idPrefix}>
                <Select
                  value={logging_language}
                   id={"logging_language_id" + idPrefix}
 data-tooltip-id={"logging_language_tooltip_id" + idPrefix}                   labelText="Language"
                  onChange={(evt) => { updatelogging_language(evt); handleChange(); }}>
                  <SelectItem text="" value="" />
                  <SelectItem text="cs" value="cs" />
                  <SelectItem text="de" value="de" />
                  <SelectItem text="en" value="en" />
                  <SelectItem text="es" value="es" />
                  <SelectItem text="fr" value="fr" />
                  <SelectItem text="hu" value="hu" />
                  <SelectItem text="it" value="it" />
                  <SelectItem text="ja" value="ja" />
                  <SelectItem text="ko" value="ko" />
                  <SelectItem text="pl" value="pl" />
                  <SelectItem text="pt" value="pt" />
                  <SelectItem text="ru" value="ru" />
                  <SelectItem text="zh_CN" value="zh_CN" />
                  <SelectItem text="zh_TW" value="zh_TW" />
                </Select>
          <ReactTooltip id={"logging_language_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>Specifies the language in which the log messages will be displayed. The LANG environment variable, if set, will take precedence over this configuration entry.  The following languages are supported:<br/>Language Code | Language ------------- | -------- cs | Czech de | German en | English es | Spanish fr | French hu | Hungarian it | Italian ja | Japanese ko | Korean pl | Polish pt | Brazilian Portuguese ru | Russian zh_CN | Chinese (Simplified) zh_TW | Chinese (Traditional)<br/></div></ReactTooltip>
                </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"tracing_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading logging_div" + idPrefix}>
                  <span className="iag_breadcrumb">Logging : </span><br/>                  <h2>Tracing Settings</h2><hr/>
                </div>
                <div className={"iag--simple-div logging_div" + idPrefix}>
                <div className= {"iag_form_elem logging_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"logging_tracing_tooltip_id" + idPrefix} >Tracing</h3><hr/>
</div>
          <ReactTooltip id={"logging_tracing_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>Specifies an array of trace components to be enabled. Tracing can be used to assist with problem determination in the environment.<br/></div></ReactTooltip>

                <div id={"logging_tracingTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem logging_div" + idPrefix}>
                    <DataTable id={"logging_tracingTable" + idPrefix} isSortable
                        headers={logging_tracingheaderData}
                        rows={logging_tracingrowData.logging_tracing}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {logging_tracinghandleAdd(idPrefix, [setlogging_tracing_component(''),    setlogging_tracing_component_valid(true),    setlogging_tracing_compress(true),    setlogging_tracing_file_name(''),    setlogging_tracing_file_name_valid(true),    setlogging_tracing_level(0),    setlogging_tracing_max_file_size(1),    setlogging_tracing_max_rollover_files(1),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <LoggingtracingDeleteModal row={row} loadGrid={logging_tracingloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <LoggingtracingEdit  data={logging_tracingrowData.logging_tracing} setData={setDataMain} row={row} loadGrid={logging_tracingloadGrid} dataLoad={dataLoad} editing={true} name={"logging_tracing"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updatelogging_tracing_component={updatelogging_tracing_component} logging_tracing_component={logging_tracing_component}
            logging_tracing_component_valid={logging_tracing_component_valid}
            logging_tracing_component_invalid_text={logging_tracing_component_invalid_text}
            updatelogging_tracing_compress={updatelogging_tracing_compress} logging_tracing_compress={logging_tracing_compress}
            updatelogging_tracing_file_name={updatelogging_tracing_file_name} logging_tracing_file_name={logging_tracing_file_name}
            logging_tracing_file_name_valid={logging_tracing_file_name_valid}
            logging_tracing_file_name_invalid_text={logging_tracing_file_name_invalid_text}
            updatelogging_tracing_level={updatelogging_tracing_level} logging_tracing_level={logging_tracing_level}
            updatelogging_tracing_max_file_size={updatelogging_tracing_max_file_size} logging_tracing_max_file_size={logging_tracing_max_file_size}
            updatelogging_tracing_max_rollover_files={updatelogging_tracing_max_rollover_files} logging_tracing_max_rollover_files={logging_tracing_max_rollover_files}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"request_log_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading logging_div" + idPrefix}>
                  <span className="iag_breadcrumb">Logging : </span><br/>                  <h2>Request Log Settings</h2><hr/>
                  <Collapsible tabIndex="0" trigger="Defines and enables request logging">
                    <p>Defines and enables request logging.<br/><br/><h4> Log Format</h4><br/>The following directives can be added to the format property to customize the log format:<br/><br/><table style={{textAlign:'left', border:'1px solid black'}}><tbody><tr style={{textAlign:'left', border:'1px solid black'}}><th style={{borderRight:'1px solid black', padding: '10px'}}>Directive </th><th style={{borderRight:'1px solid black', padding: '10px'}}> Description</th></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%a </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Client IP Address.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%A </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Local IP Address.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%b </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Bytes in the response excluding HTTP headers in CLF format: `-` instead of 0 when no bytes are returned.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%B </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Bytes in the response excluding HTTP headers.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%&#123;attribute}C </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Attribute from the credential named `attribute`.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%&#123;cookie}e </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Contents of the Cookie `cookie` in the request.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%&#123;cookie}E </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Contents of the Cookie `cookie` in the response.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%d </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Transaction identifier, or session sequence number.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%F </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Time taken to serve the request in microseconds.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%h </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Client host.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%H </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Request protocol.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%&#123;header}i </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Contents of the Header `header` in the request.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%j </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> The name of the resource server servicing the request.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%J </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> The length of time, in microseconds, that the resource server server spent processing the request. This will include the time that it took to send the request to the server, the length of time that it took the server to process the request, and the length of time that it took to read and process the response header.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%l </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Client logname (RFC 1314) (default -).</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%m </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Request method (i.e. GET, POST, HEAD).</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%&#123;header}o </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Contents of the Header `header` in the response.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%M </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> The time, in Common Log Format, at which the request was received with millisecond precision.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%p </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Port over which the request was received.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%q </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> The decoded query string (prepended with `?` or empty).</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%Q </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> The raw query string (prepended with `?` or empty).</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%r </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> First line of the request with decoded URL.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%R </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> First line of the request with decoded URL including HTTP://HOSTNAME.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%s </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Response status.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%S </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> The hostname of the backend server which serviced this request.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%t </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Time in Common Log Format format.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%&#123;format}t </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> The time in the given format.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%T </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Time taken to serve the request in seconds, or part thereof.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%u </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Remote user.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%U </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> The URL requested.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%v </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Canonical ServerName of the server servicing the request.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%z </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> The decoded path string.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>%Z </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> The raw path string.</td></tr></tbody></table></p>
                  </Collapsible>

                </div>
                <div className={"iag--simple-div logging_div" + idPrefix}>
                <div className= {"iag_form_elem logging_div" + idPrefix}>
  <h3>File</h3><hr/>
</div>
                <div className="iag-wdgt-container" style={{marginLeft:"20px",marginBottom:"10px"}}>

                <div className= {"iag_form_elem logging_div" + idPrefix}>
          <Checkbox checked={logging_request_log_file_compress} id={"logging_request_log_file_compress_id" + idPrefix}  data-tooltip-id={"logging_request_log_file_compress_tooltip_id" + idPrefix}  labelText="Compress" onChange={(evt) => { updatelogging_request_log_file_compress(evt); handleChange(); }}/>
          <ReactTooltip id={"logging_request_log_file_compress_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>A boolean which indicates whether rolled over log files should be automatically compressed to conserve disk space.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem logging_div" + idPrefix}>
          <TextInput  value={logging_request_log_file_file_name}  id={"logging_request_log_file_file_name_id" + idPrefix}  data-tooltip-id={"logging_request_log_file_file_name_tooltip_id" + idPrefix}  labelText="File Name" onChange={(evt) => { updatelogging_request_log_file_file_name(evt); handleChange(); }}/>
          <ReactTooltip id={"logging_request_log_file_file_name_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The name of the generated log file.  If the file name is supplied without any path information the file will be written to the `/var/iag/logs` directory.  If the file name contains path information the hosting directory must be created and available before the container is started.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem logging_div" + idPrefix}>
          <NumberInput value={logging_request_log_file_max_file_size} id={"logging_request_log_file_max_file_size_id" + idPrefix}  data-tooltip-id={"logging_request_log_file_max_file_size_tooltip_id" + idPrefix}  min={1}  label="Max File Size" onChange={(evt) => { updatelogging_request_log_file_max_file_size(evt); handleChange(); }}/>
          <ReactTooltip id={"logging_request_log_file_max_file_size_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The maximum size (in MB) that the file can reach before it is rolled over.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem logging_div" + idPrefix}>
          <NumberInput value={logging_request_log_file_max_rollover_files} id={"logging_request_log_file_max_rollover_files_id" + idPrefix}  data-tooltip-id={"logging_request_log_file_max_rollover_files_tooltip_id" + idPrefix}  min={1}  label="Max Rollover Files" onChange={(evt) => { updatelogging_request_log_file_max_rollover_files(evt); handleChange(); }}/>
          <ReactTooltip id={"logging_request_log_file_max_rollover_files_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The maximum number of rollover files to be kept on disk.  When the number of rollover log files reaches the specified threshold, the oldest log file is deleted.<br/></div></ReactTooltip>
        </div>

                </div>

                <div className= {"iag_form_elem logging_div" + idPrefix}>
          <TextInput  value={logging_request_log_format}  id={"logging_request_log_format_id" + idPrefix}  data-tooltip-id={"logging_request_log_format_tooltip_id" + idPrefix}  labelText="Format" onChange={(evt) => { updatelogging_request_log_format(evt); handleChange(); }}/>
          <ReactTooltip id={"logging_request_log_format_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The format of the events written to the request log. See the Log Format table above for the available directives.<br/></div></ReactTooltip>
        </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"statistics_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading logging_div" + idPrefix}>
                  <span className="iag_breadcrumb">Logging : </span><br/>                  <h2>Statistics Settings</h2><hr/>
                  <Collapsible tabIndex="0" trigger="Configures the statistic collection and publishing capability for the gateway">
                    <p>Configures the statistic collection and publishing capability for the gateway.  The statistics for the configured components will be published to the specified statsd server over UDP.  Statistics can be used to monitor the environment, or assist with problem determination in the environment.</p>
                  </Collapsible>

                </div>
                <div className={"iag--simple-div logging_div" + idPrefix}>
                <div className= {"iag_form_elem logging_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"logging_statistics_components_tooltip_id" + idPrefix} >Components</h3><hr/>
</div>
          <ReactTooltip id={"logging_statistics_components_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>Specifies an array of statistic components to be enabled.  Refer to the troubleshooting documentation for a full description of the available component names.<br/></div></ReactTooltip>

                <div id={"logging_statistics_componentsTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem logging_div" + idPrefix}>
                    <DataTable id={"logging_statistics_componentsTable" + idPrefix} isSortable
                        headers={logging_statistics_componentsheaderData}
                        rows={logging_statistics_componentsrowData.logging_statistics_components}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {logging_statistics_componentshandleAdd(idPrefix, [setlogging_statistics_components_components(''),    setlogging_statistics_components_components_valid(true),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <LoggingstatisticscomponentsDeleteModal row={row} loadGrid={logging_statistics_componentsloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <LoggingstatisticscomponentsEdit  data={logging_statistics_componentsrowData.logging_statistics_components} setData={setDataMain} row={row} loadGrid={logging_statistics_componentsloadGrid} dataLoad={dataLoad} editing={true} name={"logging_statistics_components"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updatelogging_statistics_components_components={updatelogging_statistics_components_components} logging_statistics_components_components={logging_statistics_components_components}
            logging_statistics_components_components_valid={logging_statistics_components_components_valid}
            logging_statistics_components_components_invalid_text={logging_statistics_components_components_invalid_text}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                <div className= {"iag_form_elem logging_div" + idPrefix}>
          <NumberInput value={logging_statistics_frequency} id={"logging_statistics_frequency_id" + idPrefix}  data-tooltip-id={"logging_statistics_frequency_tooltip_id" + idPrefix}  min={1}  label="Frequency *" onChange={(evt) => { updatelogging_statistics_frequency(evt); handleChange(); }}/>
          <ReactTooltip id={"logging_statistics_frequency_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The frequency (in seconds) that statistics are sent from the memory buffer to the statsd server.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem logging_div" + idPrefix}>
          <NumberInput value={logging_statistics_port} id={"logging_statistics_port_id" + idPrefix}  data-tooltip-id={"logging_statistics_port_tooltip_id" + idPrefix}  min={0}  max={65535}  label="Port" onChange={(evt) => { updatelogging_statistics_port(evt); handleChange(); }}/>
          <ReactTooltip id={"logging_statistics_port_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The port on which the statsd server is listening for requests.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem logging_div" + idPrefix}>
          <TextInput  value={logging_statistics_server}  id={"logging_statistics_server_id" + idPrefix}  data-tooltip-id={"logging_statistics_server_tooltip_id" + idPrefix}  labelText="Server *" onChange={(evt) => { updatelogging_statistics_server(evt); handleChange(); }}/>
          <ReactTooltip id={"logging_statistics_server_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The server on which the statsd server is listening for requests.<br/></div></ReactTooltip>
        </div>

                </div>
              </TabPanel>
            </Tabs>
                  <Suspense fallback={<div></div>}>
                    <LoggingcomponentsAdd loadGrid={logging_componentsloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updatelogging_components_components={updatelogging_components_components} logging_components_components={logging_components_components}
            logging_components_components_valid={logging_components_components_valid}
            logging_components_components_invalid_text={logging_components_components_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <LoggingcomponentsEdit  loadGrid={logging_componentsloadGrid} dataLoad={dataLoad} name={"logging_components"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updatelogging_components_components={updatelogging_components_components} logging_components_components={logging_components_components}
            logging_components_components_valid={logging_components_components_valid}
            logging_components_components_invalid_text={logging_components_components_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <LoggingstatisticscomponentsAdd loadGrid={logging_statistics_componentsloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updatelogging_statistics_components_components={updatelogging_statistics_components_components} logging_statistics_components_components={logging_statistics_components_components}
            logging_statistics_components_components_valid={logging_statistics_components_components_valid}
            logging_statistics_components_components_invalid_text={logging_statistics_components_components_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <LoggingstatisticscomponentsEdit  loadGrid={logging_statistics_componentsloadGrid} dataLoad={dataLoad} name={"logging_statistics_components"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updatelogging_statistics_components_components={updatelogging_statistics_components_components} logging_statistics_components_components={logging_statistics_components_components}
            logging_statistics_components_components_valid={logging_statistics_components_components_valid}
            logging_statistics_components_components_invalid_text={logging_statistics_components_components_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <LoggingtracingAdd loadGrid={logging_tracingloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updatelogging_tracing_component={updatelogging_tracing_component} logging_tracing_component={logging_tracing_component}
            logging_tracing_component_valid={logging_tracing_component_valid}
            logging_tracing_component_invalid_text={logging_tracing_component_invalid_text}
            updatelogging_tracing_compress={updatelogging_tracing_compress} logging_tracing_compress={logging_tracing_compress}
            updatelogging_tracing_file_name={updatelogging_tracing_file_name} logging_tracing_file_name={logging_tracing_file_name}
            logging_tracing_file_name_valid={logging_tracing_file_name_valid}
            logging_tracing_file_name_invalid_text={logging_tracing_file_name_invalid_text}
            updatelogging_tracing_level={updatelogging_tracing_level} logging_tracing_level={logging_tracing_level}
            updatelogging_tracing_max_file_size={updatelogging_tracing_max_file_size} logging_tracing_max_file_size={logging_tracing_max_file_size}
            updatelogging_tracing_max_rollover_files={updatelogging_tracing_max_rollover_files} logging_tracing_max_rollover_files={logging_tracing_max_rollover_files}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <LoggingtracingEdit  loadGrid={logging_tracingloadGrid} dataLoad={dataLoad} name={"logging_tracing"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updatelogging_tracing_component={updatelogging_tracing_component} logging_tracing_component={logging_tracing_component}
            logging_tracing_component_valid={logging_tracing_component_valid}
            logging_tracing_component_invalid_text={logging_tracing_component_invalid_text}
            updatelogging_tracing_compress={updatelogging_tracing_compress} logging_tracing_compress={logging_tracing_compress}
            updatelogging_tracing_file_name={updatelogging_tracing_file_name} logging_tracing_file_name={logging_tracing_file_name}
            logging_tracing_file_name_valid={logging_tracing_file_name_valid}
            logging_tracing_file_name_invalid_text={logging_tracing_file_name_invalid_text}
            updatelogging_tracing_level={updatelogging_tracing_level} logging_tracing_level={logging_tracing_level}
            updatelogging_tracing_max_file_size={updatelogging_tracing_max_file_size} logging_tracing_max_file_size={logging_tracing_max_file_size}
            updatelogging_tracing_max_rollover_files={updatelogging_tracing_max_rollover_files} logging_tracing_max_rollover_files={logging_tracing_max_rollover_files}
                    />
                  </Suspense>
              </div>
            </div>
          </div>
        </div>
    );
};
export default LoggingPage;
